import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import Moment from 'moment'
import moment from 'moment'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';


export default class ViewofReviewProcesses extends Component {
    constructor(props) {
        super(props)
        this.state = {
            reportOfreviewProcess: {
                orgCode: props.match.params.orgcode,
                reviewofauditprocessUrl: "",

            },
            data: {},
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedProcessUrl: "",
            submitStatus: false,
            editStatus: false,
            showMessage: false,
            uploadStatus : true,
            messageforvalidation :"none",
            isLoading:false
        }
        this.viewprocessUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    componentDidMount() {
        const api = APIURL + '/api/rfq/get/orgdetails/' + this.state.reportOfreviewProcess.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
        .then(res => {
                if (res.data.errorCode === 0) {
                    this.setState({ data: res.data.response })

                    if (res.data.response.auditPlanStatus) {
                        this.setState({ editStatus: true })
                        if (this.state.data.reviewofauditprocessUrl) {
                            this.setState({ uploadedProcessUrl: this.state.data.reviewofauditprocessUrl })
                            this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block", downloadbuttonStatus: "none" })
                        }
                        else if (!this.state.data.reviewofauditprocessUrl) {
                            this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", downloadbuttonStatus: "block" })
                        }
                    } else {
                        this.setState({ editStatus: false, message: "Need to Fill the Audit Plan Data", showMessage: true })
                    }
                }
            })
            .catch(e => {
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);
    
                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                    //alert("if")
                    this.setState({isLoading:true})
                }
            })


    }
    handleprocessreview = (event) => {
        event.preventDefault();
        let newArr = this.viewprocessUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        var file1 = Math.round((file.size / 1024));
        if(file1 <= 3072 ){
        S3FileUpload
            .uploadFile(file, this.state.config)
            .then(data => {
                console.log("data s3", data)
                var tempData = this.state.reportOfreviewProcess;
                tempData.reviewofauditprocessUrl = data.location
                var docType = this.checkFileExtension(data.location)
                var file= data.key.split("/")
                var fileName = file[1];
                this.setState({ 
                    reviewofauditprocessUrl: tempData, 
                    showFile: docType ,
                    uploadStatus :false, 
                    messageforvalidation : "none",
                    fileToUpload : data.location,
                    filenameToview : fileName
                });
            })
            .catch(err => console.error(err))
        }
        else{
            this.setState({filenameToview : "",messageforvalidation : "block"})
        }
    };

    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }

    removeDoc = () => {
        var tempData = this.state.reportOfreviewProcess;
        tempData.reviewofauditprocessUrl = ""
        this.setState({ reportOfreviewProcess: tempData,uploadStatus :true });
    }
    removeUplodedDoc = () => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest ={
                        "orgCode" :this.state.data.orgCode
                    }
                    axios.patch(APIURL + "/api/rfq/patch/reviewofauditprocessUrl",jsonRequest)
                    .then((res) => {
                        if (res.data.errorCode === 0) {
                    this.setState({ 
                         uploadDocumentStatus: "block",
                         uploadedDocumentStatus: "none", 
                         uploadProcessUrl: "" ,
                         uploadStatus : true ,
                         uploadedProcessUrl:"",
                         editStatus : true
                        })
                    }
                    else {
                        ToastInstance('Error', 'Something Went Wrong')
                    }
                   
                })
                .catch(err => {
                    ToastInstance('warning', 'Something Went Wrong..Please Try again')
                })
    
            }
        })
    }
    handleRoute = () => {
        window.location.href = "/" + localStorage.getItem("role") + '/reviewofauditprocesses/' + this.state.reportOfreviewProcess.orgCode;
    }

    generateReviewProcess = () => {
        return axios.get(APIURL + '/api/generatepdf/get/reviewprocesspdf/' + this.state.reportOfreviewProcess.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.data.orgSerialNumber + '-Review Of Audit Process' + `.pdf`
                link.click()
            })


    }

    postData = () => {
        var jsonRequest = {
            orgCode: this.state.reportOfreviewProcess.orgCode,
            reviewofauditprocessUrl: this.state.reportOfreviewProcess.reviewofauditprocessUrl,
        }
        console.log("json", jsonRequest)
        axios.patch(APIURL + "/api/rfq/patch/reviewofauditprocessurl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    ToastInstance('Success', 'Review Audit Process Updated')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link", link)
        link.href = this.state.uploadedProcessUrl
        window.open(link)
    }
    render() {
        const FileReviewProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.reportOfreviewProcess.reviewofauditprocessUrl} style={{ width: '80px', height: '80px' }} onClick={()=>this.downloadUploadPdf()}/>
                    <p>{this.state.filenameToview}</p>
                    <span>
                        <h6 onClick={() => this.removeDoc('reviewofauditprocessUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                <div className="row">
                <div className="col-sm-12">
                        <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} />
                        <span>
                            <h6 onClick={() => this.removeDoc('reviewofauditprocessUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times" onClick={() => this.downloadUploadPdf()}></i></h6>
                        </span>
                        </div>
                         <div className="row">
                             <span>{this.state.filenameToview}</span>

                         </div>
                     </div>
                    :
                    <>
                        <input type='file' ref={this.processUrlInput} onChange={this.handleprocessreview} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">

                            <div className="row">
                                {
                                    this.state.showMessage ?

                                        <div className="text-center"><p style={{ fontSize: "25Px", color: "red" }}>{this.state.message}</p></div>
                                        :
                                        null
                                }
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "50px" }}>
                                        <div className="row">
                                            <div className="col-sm-12">

                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name of Audited Organization</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>

                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date(s) of Audit Conducted</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.dateofaudit).format('DD-MMM-YYYY')}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Lead Auditor</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.teamleaderName}</p>

                                                    </div>

                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Ref No.</label>

                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.refno}</p>

                                                    </div>
                                                </div>
                                                <br />
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-6 labelsize">Review Acceptance: for no Conflict of interest with the above organization.</label>
                                                    <div className="col-sm-6">
                                                        <p>{this.state.data.remarkofstage}</p>

                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row headingcolor">
                                                    <div className="col-sm-6 text-dark">
                                                        {/* <h5 className="mb-3">Attendance Sheet Table</h5> */}
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row ">
                                                    <table className="table table-bordered ">
                                                        <thead className="table-primary">
                                                            <tr className="fontcontractviewtable">
                                                                <th>Sr No</th>
                                                                <th scope="col" className="text-center" width="50%">ASPECT TO VERIFY</th>
                                                                <th scope="col" className="text-center">YES/ NO/NA</th>
                                                                <th scope="col" className="text-center">REMARK/ DETAILS (IF ANY)</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            <tr >
                                                                <td className="text-center" >1.</td>
                                                                <td className="fontcontractviewtable">Audit Contracts have been signed prior to.
                                                                </td>

                                                                <td className="text-center" > <p className="mt-4">{this.state.data.conaudittracts}</p> </td>
                                                                <td > <p className="mt-4">{this.state.data.remarkconaudittracts}</p> </td>

                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">2.</td>
                                                                <td className="fontcontractviewtable">		Audit Notification and assignment of auditor sign prior to audit. With Auditor/ Industrial declaration for no conflict of interest has been signed.</td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.auditnotification}</p></td>

                                                                <td> <p className="mt-4">{this.state.data.remarkauditnotification}</p> </td>


                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">3.</td>
                                                                <td className="fontcontractviewtable">Controlled/ uncontrolled copies of the manual were received & reviewed by the auditor (Mandatory if offsite document reviews)
                                                                </td>
                                                                <td className="text-center" > <p className="mt-4">{this.state.data.controlledcopies}</p> </td>

                                                                <td> <p className="mt-4">{this.state.data.remarkcontrolled}</p> </td>

                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">4.</td>
                                                                <td className="fontcontractviewtable">The Manual Review covered all sections of the manual & all elements of the standard. As with LA Approval (Manual Reviews)
                                                                </td>
                                                                <td className="text-center" > <p className="mt-4">{this.state.data.manualreview}</p></td>

                                                                <td> <p className="mt-4">{this.state.data.remarkmanualreview}</p></td>


                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">5.</td>
                                                                <td className="fontcontractviewtable">Total Number of Employees verified, list attached and audit mandays decided </td>
                                                                <td className="text-center" >  <p className="mt-4"> {this.state.data.totalnumberemployees}</p> </td>
                                                                <td> <p className="mt-4">{this.state.data.remarktotalnumberemployees}</p> </td>

                                                            </tr>

                                                            <tr>
                                                                <td className="text-center">6.</td>
                                                                <td className="fontcontractviewtable">Opening and Closing meeting done as per scheduled time & meeting prompter covered as per checklist.
                                                                </td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.closingmeeting}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkclosingmeeting}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">7.</td>
                                                                <td className="fontcontractviewtable">Audit date and Duration followed.
                                                                </td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.durationauditdate}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkdurationauditdate}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">8.</td>
                                                                <td className="fontcontractviewtable">Scope capability verification done and audit scope decided.
                                                                </td>
                                                                <td className="text-center" > <p className="mt-4">{this.state.data.scopecapability}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkscopecapability}</p></td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">9.</td>
                                                                <td className="fontcontractviewtable">Exclusion of ISO clauses verified and accepted
                                                                    Justification by client Verified?
                                                                </td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.exclusion}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkexclusion}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">10.</td>
                                                                <td className="fontcontractviewtable">If any Outsource process identified and control over verified adequately.
                                                                </td>
                                                                <td className="text-center" > <p className="mt-4">{this.state.data.outsourceprocess}</p> </td>
                                                                <td> <p className="mt-4">{this.state.data.remarkoutsourceprocess}</p></td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">11.</td>
                                                                <td className="fontcontractviewtable">MR identified (is part of Top Management) & interviewed.
                                                                </td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.mridentified}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkmridentified}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">12.</td>
                                                                <td className="fontcontractviewtable">Organization Departments, Activities are identified and considered for preparing stage II audit schedule.
                                                                </td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.oraganizationdepartments}</p></td>

                                                                <td> <p className="mt-4">{this.state.data.remarkoraganizationdepartments}</p></td>

                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">13.</td>
                                                                <td className="fontcontractviewtable">Organization site addresses verified & address proof documents attached.
                                                                </td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.organizationsite}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkorganizationsite}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">14.</td>
                                                                <td className="fontcontractviewtable">If any modification in scope has assessed and/or scope decided by lead auditor+ client Unanimously and is Accepted with sign.
                                                                </td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.modificationinscope}</p></td>

                                                                <td> <p className="mt-4">{this.state.data.remarkmodificationinscope}</p></td>

                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">15.</td>
                                                                <td className="fontcontractviewtable">Applicability of Statutory & regulatory requirement verified, identified
                                                                </td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.applicablityofstatutory}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkapplicablityofstatutory}</p> </td>

                                                            </tr>

                                                            <tr>
                                                                <td className="text-center">16.</td>
                                                                <td className="fontcontractviewtable">Adequacy of Internal Audit Verified Including following <br />
                                                                    {/* a)Planned Frequency<br />
                                                                            b)Conducted on<br />
                                                                            c)NC raised if any<br />
                                                                            d)CAPA plan submitted and NC closing status */}
                                                                </td>
                                                                <td className="text-center" >  <p className="mt-4">{this.state.data.internalauditverified}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkinternalauditverified}</p></td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td> a)Planned Frequency</td>
                                                                <td  className="text-center" ><p className="mt-4">{this.state.data.plannedfreq}</p></td>
                                                                <td><p className="mt-4">{this.state.data.remarkplannedfreq}</p></td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td> b)Conducted on</td>
                                                                <td  className="text-center" ><p className="mt-4">{this.state.data.conductedon}</p></td>
                                                                <td><p className="mt-4">{this.state.data.remarkconductedon}</p></td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td>c)NC raised if any</td>
                                                                <td  className="text-center" ><p className="mt-4">{this.state.data.ncraisedifany}</p></td>
                                                                <td><p className="mt-4">{this.state.data.remarkncraisedifany}</p></td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td>d)CAPA plan submitted and NC closing status</td>
                                                                <td  className="text-center" ><p className="mt-4">{this.state.data.capaplanandncclosing}</p></td>
                                                                <td><p className="mt-4">{this.state.data.remarkcapaplanandncclosing}</p></td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">17.</td>
                                                                <td className="fontcontractviewtable">Adequacy of Management Review Including following <br />
                                                                    {/* a)Planned Frequency<br />
                                                                            b)Conducted on<br />
                                                                            c)Output Decision<br /> */}
                                                                </td>
                                                                <td  className="text-center" >  <p className="mt-4">{this.state.data.adequencyofmanagement}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkadequencyofmanagement}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td>a)Planned Frequency</td>
                                                                <td  className="text-center" >  <p className="mt-4">{this.state.data.plannedfreq1}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkplannedfreq1}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td> b)Conducted on</td>
                                                                <td  className="text-center" >  <p className="mt-4">{this.state.data.conductedon1}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkconductedon1}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td> c)Output Decision</td>
                                                                <td  className="text-center" > <p className="mt-4">{this.state.data.outputdecision}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkoutputdecision}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">18.</td>
                                                                <td className="fontcontractviewtable">If any Areas of concerns addressed- Sufficient time given to resolve it before stage II audit with date/s decided has given to client? </td>
                                                                <td  className="text-center" > <p className="mt-4">{this.state.data.areasconcerns}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkareasconcerns}</p> </td>
                                                            </tr>

                                                            <tr>
                                                                <td className="text-center">19.</td>
                                                                <td className="fontcontractviewtable">If Positive Findings addressed covered</td>
                                                                <td  className="text-center" > <p className="mt-4">{this.state.data.positivefindings}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkpositivefindings}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">20.</td>
                                                                <td className="fontcontractviewtable">Effectiveness of QMS implementation verified</td>
                                                                <td  className="text-center" > <p className="mt-4">{this.state.data.effectivenessqms}</p> </td>
                                                                <td> <p className="mt-4">{this.state.data.remarkeffectivenessqms}</p> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">21.</td>
                                                                <td className="fontcontractviewtable">Recommendation by Auditor</td>
                                                                <td  className="text-center" >  <p className="mt-4">{this.state.data.recommendationauditor}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkrecommendationauditor}</p></td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">22.</td>
                                                                <td className="fontcontractviewtable">Adequacy of Audit Report for going for Stage II auditr</td>
                                                                <td  className="text-center" >  <p className="mt-4">{this.state.data.adequacyofauditReport}</p></td>
                                                                <td> <p className="mt-4">{this.state.data.remarkadequacyofauditReport}</p></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <div>
                                                        <div className="row mt-4">
                                                            <hr className="mt-4" />
                                                            <div className="col-sm-6 text-dark ">
                                                                <h5>Download Review Audit Process Report</h5>
                                                            </div>
                                                            <div className="col-sm-4"/>
                                                                <button className="btn btn-primary btn-sm col-sm-2 mb-2 ml-2" onClick={() => this.generateReviewProcess()}>Download</button>
                                                          
                                                            <hr />
                                                        </div>
                                                        {
                                                            localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                                ""
                                                                :
                                                                <div style={{ display: this.state.uploadDocumentStatus }}>
                                                                    <div className="row mt-4">
                                                                        <hr className="mt-4" />
                                                                        <div className="col-sm-6 text-dark ">
                                                                            <h5>Upload Review Audit Process Report</h5>
                                                                        </div>
                                                                        <hr />



                                                                        <div className="row mt-5" >
                                                                            <div className="col-sm-4"><label htmlFor="staticEmail" ><strong>Upload Review Audit Process</strong> </label></div>
                                                                            <div className="col-sm-6">
                                                                                {
                                                                                    this.state.reportOfreviewProcess.reviewofauditprocessUrl !== "" ?
                                                                                        <FileReviewProcess />
                                                                                        :
                                                                                        <>
                                                                                            <input type='file' ref={this.viewprocessUrlInput} onChange={this.handleprocessreview} />
                                                                                            <br></br>

                                                                                        </>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-sm-10" />
                                                                        <button type="button" className="btn btn-sm btn-success col-sm-2 mb-2 mr-2" onClick={() => this.postData()}>Upload</button>

                                                                    </div>
                                                                </div>
                                                        }
                                                    </div>

                                                    <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                        <div className="row mt-5" >
                                                            <hr className="mt-4" />
                                                            <div className="col-sm-6 text-dark ">
                                                                <h5>Uploaded Review Audit Process</h5>
                                                            </div>
                                                            <hr />
                                                            <div className="col-sm-4">

                                                                <label className="mt-4">
                                                                    Uploaded Review Audit Process
                                                                </label>

                                                            </div>
                                                            <div className="col-sm-6">
                                                                {
                                                                    this.state.uploadedProcessUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                        <>
                                                                            <img className="img-fluid" src={this.state.uploadedProcessUrl} style={{ width: '80px', height: '80px' }} onClick={()=>this.downloadSignedPdf()}/>
                                                                            <p>{this.state.filenameToview}</p>
                                                                            {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                        ""
                                                                        :
                                                                            <span>
                                                                                <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                            </span>
                                                                       }
                                                                       </>
                                                                       :
                                                                        this.state.uploadedProcessUrl.match(/\.(pdf)$/) ?
                                                                            <>
                                                                                <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} />
                                                                                { 
                                                                             localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                             ""
                                                                             :
                                                                                <span>
                                                                                    <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                </span>
                                                                          }
                                                                          </>

                                                                      :
                                                                      ""
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                                {
                                                      localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      
                                                      !this.state.uploadedProcessUrl  ?
                                                      <>
                                                     
                                                     
                                                         <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>
                                                             
                                                               </> 
                                                                
                                                                :
                                                                ""
                                                                :
                                                                ""

                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
                {
                    localStorage.getItem("userRole") === "Management" || localStorage.getItem("userRole") === "Accounts" || localStorage.getItem("userRole") === "Executive(Support)" ?
                        ""
                        :
                        <div className="card-footer">
                        <div className="row">
                        <div className="col-sm-10"></div>
                        <div className="col-sm-2">
                            {
                            
                            this.state.editStatus  ?
                            ! this.state.uploadedProcessUrl ?

                            <button type="submit" className="btn btn-primary float-right" onClick={() => this.handleRoute()}>Edit</button>
                            : 
                            <div></div>
                            :"" 
                            
                        
                        }
                            </div>
                        
                    </div>
                    </div> 
                }

            </div>

        )
    }
}
